import { siteConfig } from "@acme/config";
import { Link } from "@tanstack/react-router";
import { getFooterLinks } from "~/lib/constants/navbar";
import * as m from "~/paraglide/messages.js";
import { SiteLogo } from "./site-logo";

/**
 * The design's footer: wordmark and one-line positioning on the left, every
 * route the header does not carry in the middle, copyright on the right.
 *
 * The language switcher used to live here; it is in the header now, where it
 * is reachable from /chat too.
 */
const Footer = () => (
  <footer className="wrap site-footer">
    <div>
      <SiteLogo />
      <span>{m.footer_tagline()}</span>
    </div>

    {/* `exact`: the footer is a site map, not a section indicator. Without it
        the router marks the listing as the current page while the reader is on
        an article or a case study under it. */}
    <nav aria-label={m.nav_footer_label()}>
      {getFooterLinks().map((link) => (
        <Link
          activeOptions={{ exact: true }}
          activeProps={{ "aria-current": "page" }}
          key={link.href}
          to={link.href}
        >
          {link.title}
        </Link>
      ))}
    </nav>

    <div className="footer-end">
      <span>
        © {new Date().getFullYear()} {siteConfig.name}
      </span>
    </div>
  </footer>
);

export default Footer;
